import React from "react";
import { ButtonEdit, EditElementClick } from "../../common/Buttons";

function TableColumnStatuses({ item, index, onEdit }) {
  const identifier_prettier = () => {
    if (!item.identifier) return "";

    switch (item.identifier) {
      case "new":
        return "NEW";
      case "in_progress":
        return "In progress";
      case "finished":
        return "Finished";
      case "canceled":
        return "Canceled";
      default:
        return "";
    }
  };
  return (
    <tr className="align-middle tableColumn" key={index}>
      <td className="align-middle">{item.id}</td>
      <td className="align-middle">
        <EditElementClick
          name={item.id_status}
          onEdit={() => onEdit(index, item.id)}
        />
      </td>
      <td className="align-middle">
        [{item?.order_shop?.identifier || ""}] {item.title}
      </td>
      <td className="align-middle">{identifier_prettier()}</td>
      <td className="align-middle" style={{ width: "50px" }}>
        <ButtonEdit onEdit={() => onEdit(index, item.id)} />
      </td>
    </tr>
  );
}

export default TableColumnStatuses;
